/*
 * Root Saga
 */

import { bootstrapSagas } from '@app/modules/bootstrap/sagas';
import { authSagas } from '@app/modules/auth';
import { departmentSagas } from '@app/modules/departments';
import { designationSagas } from '@app/modules/designation/sagas';
import { myProfileSagas } from '@app/modules/my-profile';
import { employeeSagas } from '@app/modules/employees';
import { roleSaga } from '@app/modules/role';
import { clientsSagas } from '@app/modules/clients';
import { assetSagas } from '@app/modules/assets';
import { holidaySagas } from '@app/modules/holidays';
import { leaveManagementSagas } from '@app/modules/leave-setting';
import { leaveSagas } from '@app/modules/add-leave-employee';
import { candidateSagas } from '@app/modules/candidates';
import { documentsSagas } from '@app/modules/documents';
import { IntervieweeSagas } from '@app/modules/interviewee';
import { internSagas } from '@app/modules/intern';
import { projectSagas } from '@app/modules/projects';
import { portfolioSagas } from '@app/modules/portfolio';
import { testimonialSagas } from '@app/modules/client-testimonial';
import { reviewsSagas } from '@app/modules/reviews';
import { DashboardSagas } from '@app/modules/dashboard';
import { ManagerDashboardSagas } from '@app/modules/manager-dashboard';
import { taskBoardSagas } from '@app/modules/task-board';
import { myTasksSagas } from '@app/modules/tasks';
import { overdueTasksSagas } from '@app/modules/overdueTasks';
import { etaSagas } from '@app/modules/eta';

const rootSaga = [
  bootstrapSagas,
  authSagas,
  departmentSagas,
  designationSagas,
  roleSaga,
  myProfileSagas,
  employeeSagas,
  clientsSagas,
  assetSagas,
  holidaySagas,
  leaveManagementSagas,
  leaveSagas,
  candidateSagas,
  documentsSagas,
  IntervieweeSagas,
  internSagas,
  projectSagas,
  portfolioSagas,
  testimonialSagas,
  reviewsSagas,
  DashboardSagas,
  ManagerDashboardSagas,
  taskBoardSagas,
  myTasksSagas,
  overdueTasksSagas,
  etaSagas,
];

export { rootSaga };
